import React from 'react';
import { Mountain, Tent, PawPrint, ChevronDown } from 'lucide-react';

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_cosy-huts-camp/artifacts/5tj4otnw_1000030873.png"
          alt="Top of the Rock Glamping"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-6 py-3 text-white">
            <Mountain className="w-5 h-5 text-emerald-300" />
            <span className="text-sm font-medium">Pen Y Graig Farm, Welsh Mountains</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight">
            Escape to Nature at
            <span className="block mt-2 text-emerald-300">Top of the Rock</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl sm:text-2xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            Luxury shepherd's huts and private camping in the heart of the Welsh mountains. 
            Perfect for romantic getaways and adventure seekers.
          </p>

          {/* Features */}
          <div className="flex flex-wrap justify-center gap-6 pt-4">
            <div className="flex items-center space-x-2 text-white">
              <Tent className="w-5 h-5 text-emerald-300" />
              <span className="font-medium">3 Luxury Huts</span>
            </div>
            <div className="flex items-center space-x-2 text-white">
              <Mountain className="w-5 h-5 text-emerald-300" />
              <span className="font-medium">2 Private Pitches</span>
            </div>
            <div className="flex items-center space-x-2 text-white">
              <PawPrint className="w-5 h-5 text-emerald-300" />
              <span className="font-medium">Dog Friendly</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-emerald-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-emerald-700 transition-all hover:shadow-2xl hover:scale-105"
            >
              Book Your Stay
            </button>
            <button
              onClick={() => scrollToSection('accommodation')}
              className="bg-white/10 backdrop-blur-md border border-white/30 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white/20 transition-all"
            >
              View Accommodation
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={() => scrollToSection('accommodation')}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white animate-bounce cursor-pointer hover:text-emerald-300 transition-colors"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
};
